import { Box, Flex, Image, Link, NativeSelect, Text } from '@chakra-ui/react'
import { LANGUAGES } from 'commons/constants/language'
import { PaymentPageTermsUrls, PrivacyPolicyUrls } from 'commons/constants/supportUrls'
import { BorderRadius, Spacing, TextColors } from 'commons/design-system/tokens'
import { useTranslation } from 'react-i18next'

export const SuccessPageFooter = () => {
	const { t, i18n } = useTranslation()

	const links = {
		about:
			i18n.language === LANGUAGES.FRENCH
				? 'https://support.lydia.me/l/fr/article/zma7sln6cm-tout-savoir-sur-la-s-curit-de-lydia'
				: 'https://support.lydia.me/l/en/article/zma7sln6cm-what-are-the-app-s-security-measures',
		terms:
			i18n.language === LANGUAGES.FRENCH
				? PaymentPageTermsUrls[LANGUAGES.FRENCH]
				: PaymentPageTermsUrls[LANGUAGES.ENGLISH],
		privacy:
			i18n.language === LANGUAGES.FRENCH
				? PrivacyPolicyUrls[LANGUAGES.FRENCH]
				: PrivacyPolicyUrls[LANGUAGES.ENGLISH]
	}

	const languageOptions = [
		{ value: LANGUAGES.FRENCH, flag: '🇫🇷' },
		{ value: LANGUAGES.ENGLISH, flag: '🇬🇧' }
	]

	return (
		<Box
			as='footer'
			w='100%'
			bg='rgba(255, 255, 255, 0.75)'
			backdropFilter='blur(9px)'
			py={Spacing.L}
			px={{ base: Spacing.M, md: Spacing.ML }}
			mt='auto'
		>
			<Flex
				align={{ base: 'center', md: 'flex-end' }}
				justify={{ base: 'center', md: 'space-between' }}
				direction={{ base: 'column-reverse', md: 'row' }}
				gap={Spacing.M}
				w='100%'
			>
				<Flex direction='column' align={{ base: 'center', md: 'flex-start' }} gap={Spacing.XS}>
					<Image
						src={`${process.env.REACT_APP_POTS_URL}collect/assets/img/logos/new-lydia-dark.png`}
						alt='Lydia Logo'
						w='100px'
						h='auto'
					/>
					<Text
						fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
						fontSize='12px'
						fontWeight={500}
						color={TextColors.PRIMARY}
						textAlign={{ base: 'center', md: 'left' }}
					>
						{t('success.footer_copyright', { year: new Date().getFullYear() })}
					</Text>
				</Flex>
				<Flex
					align='center'
					justify={{ base: 'center', md: 'flex-end' }}
					gap={Spacing.SM}
					flexWrap='wrap'
				>
					<Link
						href={links.about}
						fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
						fontSize='14px'
						fontWeight={700}
						color={TextColors.PRIMARY}
						target='_blank'
						rel='noopener noreferrer'
						_hover={{ textDecoration: 'underline' }}
					>
						{t('success.footer_about_security')}
					</Link>
					<Link
						href={links.terms}
						fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
						fontSize='14px'
						fontWeight={700}
						color={TextColors.PRIMARY}
						target='_blank'
						rel='noopener noreferrer'
						_hover={{ textDecoration: 'underline' }}
					>
						{t('success.footer_terms')}
					</Link>
					<Link
						href={links.privacy}
						fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
						fontSize='14px'
						fontWeight={700}
						color={TextColors.PRIMARY}
						target='_blank'
						rel='noopener noreferrer'
						_hover={{ textDecoration: 'underline' }}
					>
						{t('success.footer_privacy')}
					</Link>
					<Box w={{ base: '100%', md: 'auto' }} display='flex' justifyContent='center'>
						<NativeSelect.Root size='sm' w='56px'>
							<NativeSelect.Field
								value={i18n.language}
								onChange={(e) => i18n.changeLanguage(e.target.value)}
								border='1px solid'
								borderColor={TextColors.QUATERNARY}
								borderRadius={BorderRadius.S}
								fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
								fontWeight={600}
								color={TextColors.PRIMARY}
								cursor='pointer'
								bg='white'
								_hover={{ borderColor: TextColors.TERTIARY }}
								px='6px'
							>
								{languageOptions.map((opt) => (
									<option key={opt.value} value={opt.value}>
										{opt.flag}
									</option>
								))}
							</NativeSelect.Field>
							<NativeSelect.Indicator />
						</NativeSelect.Root>
					</Box>
				</Flex>
			</Flex>
		</Box>
	)
}
